module.exports = {"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"貨Van價目表":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/zh_hk/setting/pricing/setting.json
// module id = 627
// module chunks = 0 1 2 3 4 5